module.exports = __webpack_public_path__ + "img/logo.3ff33feb.svg";